<berry-popover (onStatusChange)="arrowControl[0] = !arrowControl[0]" #popover placement="bottom" [id]="id" (onStatusChange)="onStatusChange($event)" [reversePlacement]="reversePlacement">
    <div class="w-100" toggle>
        <berry-button [class.isMenuOpenActiveClass]="buttonType == 'secondary' && arrowControl[0]" [isOutlinedStartIcon]="showResultIcon ? false : true" [disabled]="disabled" [withBorder]="!!text && withBorder"
                      [data-automation-id]="dataAutomationId"
                      [typoWeight]="typoWeight"
                      [size]="buttonSize" [class]="optionColorIconSelcted"
                      [leftIcon]="startIcon" [type]="buttonType" [style]="buttonStyle"
                      [rightIcon]="leftIcon == 'arrow_drop_down' ? (
                        !!!arrowControl[0] ? 'arrow_drop_down' : 'arrow_drop_up'
                      ) : leftIcon"
                      [label]="label"
                      [bottonType]="buttonActionType" />

    </div>
    <div body class="menuContainer radius_sm removeBoxShadow">

        <div class="dropdownMenuContainer" [class.width-auto]="!isFixedWidth">
            <ng-container *ngFor="let action of actions; let i = index">

                <div class="divider1 divider1__horizontal height-2 mh-2" *ngIf="showLastItemIndex && i == actions.length - 1"></div>

                <div class="dropdownMenuContainer-item"
                     [class.disabled]="action.disabled"
                     [attr.data-automation-id]="action?.dataAutomationId"
                     [ngClass]="{'disabled': action?.disabled}"
                     [title]="!action.tooltip ? '' : (action.tooltip | translate)"
                     (click)="!action.disabled && action.event(data,index);getOptionSelctedText(action.title);getOptionSelctedIcon(action.icon, action.iconColor)"
                     *ngIf="action.showOption != false">
                    <berry-icon [isOutlined]="action?.isOutlinedIcon" *ngIf="!!action.icon"
                                [color]="action.iconColor || 'muted'" [name]="action.icon" [size]="24"></berry-icon>
                    <berry-typo name='body1' [weight]="500" color="primary"> {{action.title | translate}}</berry-typo>
                </div>
            </ng-container>
        </div>
    </div>
</berry-popover>
